"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.respondBase = respondBase;
exports.stripUnit = exports.fluidScaleCalc = exports.fluidScaleBase = exports.reducedMotion = void 0;
// Media mixins
// --------------------------------------------------------
// Media queries
// --------------------------------------------------------
const BREAKPOINTS = {
  130: "1280px",
  50: "516px"
}; // Responds to viewport size
// This function is meant to be used as a base for your mixin, with your defined breakpoints
// Example:
// export function respond(content, size, operator, aspect) {
//   const pxSize = breakpoints[size];
//   return respondBase(content, pxSize, operator, aspect);
// }
// $pxSize -> viewport size
// $operator -> 'min' or 'max'
// $aspect -> 'width' or 'height'

function respondBase(content, pxSize = BREAKPOINTS[50], operator = "max", aspect = "width") {
  return `
    @media all and (${operator}-${aspect}: ${pxSize}) {
      ${content}
    }
  `;
} // Respond to users with reduced motion turned on


const reducedMotion = content => {
  return `
    @media (prefers-reduced-motion: reduce) {
      ${content}
    }
  `;
}; // Fluid Elements
// --------------------------------------------------------
// Set min and max sizes and breakpoints and let  fluidly scale different properties in-between
// This function is meant to be used as a base for your mixin, with your defined breakpoints


exports.reducedMotion = reducedMotion;

const fluidScaleBase = (max, min, maxVw, minVw) => {
  const maxNum = stripUnit(max);
  const minNum = stripUnit(min);

  if (minNum > maxNum) {
    return `clamp(${max}, ${fluidScaleCalc(max, min, maxVw, minVw)}, ${min})`;
  }

  return `clamp(${min}, ${fluidScaleCalc(max, min, maxVw, minVw)}, ${max})`;
}; // return fluid-scale calc value


exports.fluidScaleBase = fluidScaleBase;

const fluidScaleCalc = (maxValue, minValue, maxVw = BREAKPOINTS[130], minVw = BREAKPOINTS[50]) => {
  return `
    calc(${minValue} + ${stripUnit(maxValue) - stripUnit(minValue)} *
    (100vw - ${minVw}) / ${stripUnit(maxVw) - stripUnit(minVw)})
  `;
}; // used by fluid-scale mixin


exports.fluidScaleCalc = fluidScaleCalc;

const stripUnit = unit => {
  return parseInt(unit.toString().replace(/[^\d\.]/g, ""));
};

exports.stripUnit = stripUnit;